import { useTranslation } from "react-i18next";
import Cards from "./cards";
import WeaklyBookings from "./weaklyBookings";
import StoreSales from "./storeSales";
import EmployeeAttendance from "./employeeAttendance";
import Notifications from "./notifications";

const Home = () => {
  const { t } = useTranslation();
  return (
    <main>
      <h1 className="mb-3 text-2xl font-bold capitalize text-primary">
        {t("dashboard")}
      </h1>
      <article className="space-y-3">
        <Cards t={t} />
        <div className="flex flex-col gap-4 lg:flex-row">
          <WeaklyBookings t={t} />
          <StoreSales t={t} />
        </div>
        <div className="flex flex-col gap-4 lg:flex-row">
          <EmployeeAttendance t={t} />
          <Notifications t={t} />
        </div>
      </article>
    </main>
  );
};

export default Home;
